export const DELIVERY_TYPE = 'DEUTSCHE_POST_PACKET'